import { useCallback } from 'react';

import { useFlowHooks } from '@eneco/flows/utils/FlowProvider';

import { FlowConsumerContextEnergy } from '../../context';

export function useFlowNavigation() {
  const { useFlowActorRef } = useFlowHooks<FlowConsumerContextEnergy>();
  const sendToFlowMachine = useFlowActorRef().send;

  const updateContextAndGoToNextStep = useCallback(
    (values: Partial<FlowConsumerContextEnergy>) => {
      sendToFlowMachine({ type: 'UPDATE_VALUES', values });
      sendToFlowMachine({ type: 'NEXT_PAGE' });
    },
    [sendToFlowMachine],
  );

  return { updateContextAndGoToNextStep };
}
